import AbstractMetadata from "../AbstractMetadata";

class EnterpriseComponentAttributePickMapMetadata extends AbstractMetadata {
    fName: string;
    fConstrain: boolean;
    fAttribute: string;
    fNoClear: boolean;
    fPickListAttribute: string;

    constructor(fName: string, fConstrain: boolean, fAttribute: string, fNoClear: boolean, fPickListAttribute: string) {
        super();

        this.fName = fName;
        this.fConstrain = fConstrain;
        this.fAttribute = fAttribute;
        this.fNoClear = fNoClear;
        this.fPickListAttribute = fPickListAttribute;
    };

    getName = () => {
        return this.fName;
    };

    getConstrain = () => {
        return this.fConstrain;
    };

    getAttribute = () => {
        return this.fAttribute;
    };

    getNoClear = () => {
        return this.fNoClear;
    };

    getPickListAttribute = () => {
        return this.fPickListAttribute;
    };
}

export default EnterpriseComponentAttributePickMapMetadata;
